import React from 'react'
import img1 from '../../images/Ellipse.webp'
import img2 from '../../images/Arrow.webp'
import img3 from '../../images/No..webp'
import img4 from '../../images/apartment.webp'
import img5 from '../../images/building.webp'
import img6 from '../../images/golf-club.webp'
import img7 from '../../images/home.webp'
import img8 from '../../images/maps.webp'
import img9 from '../../images/rupee.webp'
import img10 from '../../images/network.webp'
import sec1 from '../../images/secondSec1.webp'
import sec2 from '../../images/secondSec2.webp'
import { FaMapMarkerAlt } from "react-icons/fa";
import { Container, Row, Col } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive';

const ModernSection = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
    return (
        <>
            <div className='modern-section section-padding'>
                <Container>
                    <Row>
                        <Col lg={7} md={12} xs={12}>
                            <div className={`${isMobile ? 'text-start' : ''}`}>
                                <h1 className='primary-color'>IRA Aspiration:</h1>
                                <h1 className='primary-color'>A Modern Living Experience</h1>
                                <h6 className={`mb-20 mt-2 `}>Smart, Spacious, Connected</h6>
                            </div>
                            <Row className={`${isMobile ? 'mb-3' : 'mb-4'}`} style={{padding : isMobile ? '0px 0px 0px 16px' : ''}}>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className='w-100 facility-row'>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={img1} alt="" className='img-fluid' ></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div >
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span2'>Status</p>
                                                        <p className='sec-span2 '>Ready To Move In <br/>OC Received</p>
                                                    </>
                                                    :
                                                    <>
                                                    <p className='first-span2'>Status</p>
                                                    <p className='sec-span2 '>Ready To Move In <br/> OC Received</p>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className={`w-100 facility-row`}>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={img2} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div >
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Area</p>
                                                        <p className='sec-span'>8 Acres</p>
                                                    </>
                                                    :
                                                    <>
                                                    <span className='first-span'>Area</span><br/>
                                                    <span className='sec-span'>8 Acres</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className={`${isMobile ? 'mb-3' : 'mb-4'}`} style={{padding : isMobile ? '0px 0px 0px 16px' : ''}}>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className='w-100 facility-row'>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={img7} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Type</p>
                                                        <p className='sec-span'>Apartments</p>
                                                    </>
                                                    :
                                                    <>
                                                    <span className='first-span'>Type</span><br/>
                                                    <span className='sec-span'>Apartments</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className={`w-100 facility-row`}>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={img4} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Total Flats</p>
                                                        <p className='sec-span'>748</p>
                                                    </>
                                                    :
                                                    <>
                                                    <span className='first-span'>Total Flats</span><br/>
                                                    <span className='sec-span'>748</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className={`${isMobile ? 'mb-3' : 'mb-4'}`} style={{padding : isMobile ? '0px 0px 0px 16px' : ''}}>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className='w-100 facility-row'>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={img10} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Flat Area</p>
                                                        <p className='sec-span'>1295 To 2195 Sq. Ft.</p>
                                                    </>
                                                    :
                                                    <>
                                                    <span className='first-span'>Flat Area</span><br/>
                                                    <span className='sec-span'>1295 To 2195 Sq. Ft.</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className={`w-100 facility-row`}>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={img5} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Structure</p>
                                                        <p className='sec-span'>2B+G+9F</p>
                                                    </>
                                                    :
                                                    <>
                                                    <span className='first-span'>Structure</span><br/>
                                                    <span className='sec-span'>2B+G+9F</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className={`${isMobile ? 'mb-3' : 'mb-4'}`} style={{padding : isMobile ? '0px 0px 0px 16px' : ''}}>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className='w-100 facility-row'>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={img8} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Unit Type</p>
                                                        <p className='sec-span'>2-3 BHK</p>
                                                    </>
                                                    :
                                                    <>
                                                    <span className='first-span'>Unit Type</span><br/>
                                                    <span className='sec-span'>2-3 BHK</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className={`w-100 facility-row`}>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={img6} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Club House</p>
                                                        <p className='sec-span'>31000 SFT</p>
                                                    </>
                                                    :
                                                    <>
                                                    <span className='first-span'>Club House</span><br/>
                                                    <span className='sec-span'>31000 SFT</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className={`${isMobile ? 'mb-3' : 'mb-4'}`} style={{padding : isMobile ? '0px 0px 0px 16px' : ''}}>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className='w-100 facility-row'>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={img9} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>Pricing</p>
                                                        <p className='sec-span'>₹6,999/Sq. Ft.</p>
                                                    </>
                                                    :
                                                    <>
                                                    <span className='first-span'>Pricing</span><br/>
                                                    <span className='sec-span'>₹6,999/Sq. Ft.</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={6} md={6} xs={6}>
                                    <Row className={`w-100 facility-row`}>
                                        <Col lg={2} md={2} xs={3} className='facility-img'>
                                            <img src={img3} alt="" className='img-fluid'></img>
                                        </Col>
                                        <Col lg={10} md={10} xs={9} className={`${isMobile ? 'd-flex align-items-center' : ''}`}>
                                            <div>
                                                {isMobile ?
                                                    <>
                                                        <p className='first-span'>RERA NO</p>
                                                        <p className='sec-span'>P01100002880</p>
                                                    </>
                                                    :
                                                    <>
                                                    <span className='first-span'>RERA NO</span><br/>
                                                    <span className='sec-span'>P01100002880</span>
                                                    </>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={5} md={12} xs={12} className={`${isMobile ? 'mt-3' : 'd-flex justify-content-end'} position-relative`}>
                            {
                                isMobile ?
                                <>
                                    
                                    
                                    <div className='text-center'>
                                        <img src="/modernlivingmobile.png" className='img-fluid w-100' alt="section2-img" ></img>
                                    </div>
                                    {/* <div className='position-absolute' style={{bottom : '10%'}}>
                                        <img src={sec2} className='img-fluid' alt="section2-img" style={{width: '60%'}}></img>
                                    </div> */}
                                </>
                                : 
                                <>
                                <div className='w-100'>
                                <div className='d-flex position-absolute prime-kollur align-items-center'>
                                    <FaMapMarkerAlt size={isMobile ? 15 : 30} />
                                    <h6>Prime Kollur</h6>
                                </div>
                            </div>
                            <div className='position-absolute first-img'><img src="/modernliving.png" className='img-fluid w-100' alt="section2-img"></img></div>
                            {/* <div className='position-absolute second-img'><img src={sec2} className='img-fluid w-100' alt="section2-img"></img></div> */}
                                </>
                            }
                            
                        </Col>
                    </Row>
                </Container>
            </div>
        
        </>
    )
}

export default ModernSection
